import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'irembogov-image',
  templateUrl: './irembo-image.component.html',
  styleUrls: ['./irembo-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IremboImageComponent {
  @Input() src: string | null = null;
  @Input() desktopWidth = '300px';
  @Input() tabletWidth = '80%';
  @Input() mobileWidth = '90%';
  @Input() objectFit: 'cover' | 'contain' | 'fill' = 'cover';
  @Input() borderRadius = '0';
  @Input() alt = '';
  @Input() defaultImage = 'assets/images/noimage.png';

  private normalizeImageSource(value: string | null): string | null {
    if (!value || value.trim() === '') return null;

    // Already a valid data URI
    if (value.startsWith('data:image')) {
      const [, base64Data] = value.split(',');
      if (!base64Data || base64Data.trim() === '' || base64Data === 'null')
        return null;
      return value;
    }

    // Valid HTTP URL
    try {
      new URL(value);
      return value;
    } catch {
      // not a URL, fall through
    }

    // Looks like raw base64 — prepend the prefix
    if (/^[A-Za-z0-9+/=]+$/.test(value.trim())) {
      return `data:image/jpeg;base64,${value.trim()}`;
    }

    return null;
  }

  get imageSource(): string {
    const normalized = this.normalizeImageSource(this.src);
    return normalized ?? this.defaultImage;
  }
}
